import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import useERC20Contract from '#/hooks/use-erc20-contract';
import {useQuery} from '@tanstack/react-query';

export const useStableTokenBalance = () => {
  const erc20Contract = useERC20Contract();

  const {data: balance, ...rest} = useQuery({
    queryKey: [baseKeysUseQuery.useStableTokenBalance, erc20Contract?.account],
    queryFn: async () => {
      const res = await erc20Contract!.balanceOf();

      return {value: res};
    },
    enabled: !!erc20Contract,
  });

  return {
    data: balance?.value ?? -1n,
    ...rest,
  };
};
